export default __webpack_public_path__ + "static/media/manger_upload_format.4696ab69.csv";